import type { GalleryItem } from '../types/content';

export const gallery: GalleryItem[] = [
  // Commercial
  {
    market: 'commercial',
    title: { en: 'Office hallway repaint', es: 'Repintado de pasillo de oficinas' },
    category: { en: 'Interior · Corporate office', es: 'Interior · Oficina corporativa' },
    location: 'Dublin, Ohio',
    description: {
      en: 'Drywall repair, fresh white walls, and a navy brand accent — completed over one weekend.',
      es: 'Reparación de drywall, paredes blancas y un acento azul marino de la marca — terminado en un fin de semana.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/dbe27bbd-98df-4c95-94e3-e5287083246a.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/5f899a37-d68a-4347-b94d-75d7fbe6ef21.jpg',
    beforeAlt: { en: 'Scuffed office hallway before commercial painting in Dublin, Ohio', es: 'Pasillo de oficina deteriorado antes de la pintura comercial en Dublin, Ohio' },
    afterAlt: { en: 'Office hallway after professional commercial interior painting in Dublin, Ohio', es: 'Pasillo de oficina después de la pintura comercial interior en Dublin, Ohio' },
  },
  {
    market: 'commercial',
    title: { en: 'Storefront exterior refresh', es: 'Renovación de fachada comercial' },
    category: { en: 'Exterior · Retail', es: 'Exterior · Comercio' },
    location: 'Columbus, Ohio',
    description: {
      en: 'Scraped, primed, and repainted siding and trim with a weather-resistant exterior system.',
      es: 'Raspado, primer y nueva pintura en revestimiento y molduras con un sistema exterior resistente al clima.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/d51a7a40-b3b5-42f4-ae72-c6eef84dadf5.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/401c313d-ae16-46bd-8721-8a2889f03133.jpg',
    beforeAlt: { en: 'Faded storefront before exterior commercial painting in Columbus, Ohio', es: 'Fachada desgastada antes de la pintura exterior en Columbus, Ohio' },
    afterAlt: { en: 'Storefront after professional exterior commercial painting in Columbus, Ohio', es: 'Fachada después de la pintura exterior comercial en Columbus, Ohio' },
  },
  // Residential
  {
    market: 'residential',
    title: { en: 'Living room interior repaint', es: 'Repintado de sala' },
    category: { en: 'Interior · Single family home', es: 'Interior · Casa unifamiliar' },
    location: 'Worthington, Ohio',
    description: {
      en: 'Nail holes patched, warm greige walls, crisp white trim, and a navy accent wall behind the sofa.',
      es: 'Agujeros resanados, paredes en tono greige, molduras blancas y una pared de acento azul marino.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/e8ebe9d6-12f0-4c6a-b429-bcf14e559a48.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/c309f9be-8001-445e-91bb-75bc6aab92e4.jpg',
    beforeAlt: { en: 'Living room with dated yellow walls before interior house painting in Worthington, Ohio', es: 'Sala con paredes amarillas antes de la pintura interior en Worthington, Ohio' },
    afterAlt: { en: 'Living room after professional interior house painting in Worthington, Ohio', es: 'Sala después de la pintura interior residencial en Worthington, Ohio' },
  },
  {
    market: 'residential',
    title: { en: 'Whole-house exterior', es: 'Exterior de casa completa' },
    category: { en: 'Exterior · Single family home', es: 'Exterior · Casa unifamiliar' },
    location: 'Westerville, Ohio',
    description: {
      en: 'Siding scraped and primed, then painted slate blue with white trim, black shutters, and a green front door.',
      es: 'Revestimiento raspado y con primer, pintado en azul pizarra con molduras blancas, contraventanas negras y puerta verde.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/35c8310f-0cc4-49bd-a7d0-d40b3ebe586d.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/db707a3b-420f-4ccc-84e4-67462a9b7e29.jpg',
    beforeAlt: { en: 'House with peeling siding before exterior house painting in Westerville, Ohio', es: 'Casa con pintura descascarada antes de la pintura exterior en Westerville, Ohio' },
    afterAlt: { en: 'House after professional exterior house painting in Westerville, Ohio', es: 'Casa después de la pintura exterior residencial en Westerville, Ohio' },
  },
  {
    market: 'residential',
    title: { en: 'Kitchen cabinet refinishing', es: 'Renovación de gabinetes de cocina' },
    category: { en: 'Specialty · Cabinets', es: 'Especial · Gabinetes' },
    location: 'Dublin, Ohio',
    description: {
      en: 'Oak cabinets degreased, sanded, primed, and sprayed in satin white and navy with new hardware.',
      es: 'Gabinetes de roble desengrasados, lijados, con primer y pintados en blanco satinado y azul marino.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/c38e88d3-db6d-4dd4-9e33-3e145df6b39f.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/7570425f-a7eb-458f-acfc-5ef844a49f2c.jpg',
    beforeAlt: { en: 'Dated oak kitchen cabinets before cabinet painting in Dublin, Ohio', es: 'Gabinetes de roble antes de pintarlos en Dublin, Ohio' },
    afterAlt: { en: 'Kitchen after professional cabinet painting in Dublin, Ohio', es: 'Cocina después de la pintura de gabinetes en Dublin, Ohio' },
  },
];
